export enum HttpStatusCode {
  Success = 200,
  ERROR = 400,
  NotFound = 404,
}
